import styled from "styled-components";

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;

  @media (min-width: 600px) {
    padding: 0 24px;
  }

  @media (min-width: 960px) {
    padding: 0 32px;
  }
`;

export const Paper = styled.div`
  ${({ theme }) => `
    background-color: ${theme.tokens.color.background.primary};
    border-radius: ${theme.tokens.border.radius.sm}px;
    padding: ${theme.tokens.padding.md}px;
    border: 1px solid ${theme.tokens.color.border.primary};
  `}
`;

export const Code = styled.code`
  ${({ theme }) => `
    background-color: ${theme.tokens.color.background.secondary};
    padding: 2px 4px;
    border-radius: ${theme.tokens.border.radius.sm}px;
    font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', monospace;
    font-size: ${theme.tokens.fonts.size["0875"]}px;
  `}
`;
